import { objType } from "types"

//const homeapp: objType[] = []
const homeapp: objType[] = [{
    "id": 149,
    "lesson_id": "https://www.yisumatica.org.il/mini_apps/medume_to_meorav/index.html?image=medume_to_meorav",
    "app": " ",
    "mh_topic": 0,
    "app_type": 1,
    "app_arabic": "",
    "app_eng": "",
    "display_app_eng": "false",
    "top_topic": "שבר",
    "topic": "פעולות חשבון בשברים",
    "classes": "1234567",
    "youtube": "coJIxw5k6Ac",
    "youtube_eng": "",
    "plus": "0",
    "search_words": "",
    "search_words_eng": "",
    "interaction": "",
    "student_page": "",
    "description": "היישומון מאפשר בנקל להוביל את התלמידים להבנה ויזואלית למעבר משבר גדול מ-1 למספר מעורב",
    "description_arabic": "",
    "description_eng": "",
    "flash": "",
    "category": "",
    "origin": "apps",
    "hide": ""
  }]

export default homeapp